<template>
  <div>
    <a-modal
      v-model="visible"
      title="预估详情"
      @ok="handleOk"
      :footer="null"
      :width="800"
      :destroyOnClose="true"
    >
      <div class="card">
        <h3>输入信息</h3>
        <div class="item" v-if="details.pigFeedingProgramInfoVO">
          <a-tooltip>
            <template slot="title">
              {{details.pigFeedingProgramInfoVO.feedingName}}
            </template>
            <span class="labelText">{{
              details.pigFeedingProgramInfoVO
                ? details.pigFeedingProgramInfoVO.feedingName
                : "-"
            }}</span>
          </a-tooltip>
          <span
            >配方代码：{{
              details.pigFeedingProgramInfoVO
                ? details.pigFeedingProgramInfoVO.pigFeedingProgramWeightList
                    .length > 0
                  ? details.pigFeedingProgramInfoVO
                      .pigFeedingProgramWeightList[0].formulaCode
                  : "-"
                : "-"
            }}</span
          >
        </div>
        <div class="item">
          <span>动物类型：{{ record.animalTypeName }}</span>
          <span>预估时间：{{ record.createTime }}</span>
        </div>
      </div>
      <div class="card" v-if="predictionType == 'growingFinishing'">
        <h3>生长性能</h3>
        <template v-if="dataBase.weightRangeFormulaList">
          <div
            class="item"
            v-for="item in dataBase.weightRangeFormulaList"
            :key="item.id"
          >
            <span>开始体重：{{ item.initialBwforaa }}kg</span>
            <span>结束体重：{{ item.finalBwforaa }}kg</span>
          </div>
        </template>
      </div>
      <div class="card" v-if="predictionType == 'startingPigs'">
        <h3>生长性能</h3>
        <template v-if="dataBase.weightRangeFormulaList">
          <div
            class="item"
            v-for="item in dataBase.weightRangeFormulaList"
            :key="item.id"
          >
            <span>平均体重：{{ item.initialBwforaa }}kg</span>
          </div>
        </template>
      </div>
      <div class="card" v-if="predictionType == 'growingFinishing'">
        <h3>经济效益</h3>
        <template v-if="details.ipEconomicBenefit">
          <div class="group">
            <template v-for="item in inputEconomic">
              <div
                class="group_item"
                :key="item.feild"
                v-if="infor[item.feild]"
              >
                <span >
                  {{ item.name }}：{{ getText(item) }} {{ item.unit }}
                </span>
              </div>
            </template>
          </div>

          <!-- 饲料终端价格和他的数组 -->
          <div v-if="feedPriceDays.length>0">
            <span style="font-size:13px">饲料终端价格: </span>
            <a-table :data-source=" feedPriceDays" :columns="columnsPrice" :pagination="false" style="margin:6px 0px 10px" >
                <template slot="field" slot-scope="text, record">
                  <span>{{record.initialBw}}-{{record.finalBw}}kg</span>
                </template>
            </a-table>
          </div>
        </template>
      </div>

      <div class="card">
        <h3>预估结果</h3>
      </div>
      <div class="card">
        <h3>生长性能</h3>
        <TotalGrowproperties
          v-if="
            predictionType == 'growingFinishing' ||
            predictionType == 'startingPigs'
          "
          :details="details"
          :predictionType="predictionType"
        />
        <PregnantTotalGrowproperties
          v-if="predictionType == 'gestatingSows'"
          :details="details"
          :predictionType="predictionType"
        />
      </div>

      <div class="card" v-if="predictionType == 'growingFinishing'">
        <h3>经济效益</h3>
        <EconomicPerformance :details="details"></EconomicPerformance>
      </div>
      <div class="card">
        <AminoAcid :details="details"></AminoAcid>
      </div>
    </a-modal>
  </div>
</template>
<script>
import EconomicPerformance from "./DetailsComponents/EstimateResults/GrowProperties/EconomicPerformanceModal.vue";
import TotalGrowproperties from "./DetailsComponents/EstimateResults/GrowProperties/TotalGrowpropertiesModal.vue";
import AminoAcid from "./DetailsComponents/EstimateResults/AminoAcid/AminoAcidModal.vue";

//妊娠母猪
import PregnantTotalGrowproperties from "./DetailsComponents/EstimateResults/GrowProperties/PregnantTotalGrowpropertiesModal.vue";
import { mapState, mapMutations } from "vuex";
import { inputEconomic } from "../EstimateConfig/copyConfig";
export default {
  components: {
    EconomicPerformance,
    TotalGrowproperties,
    AminoAcid,
    PregnantTotalGrowproperties,
  },
  data() {
    return {
      visible: false,
      dataBase: {},
      record: {},
      details: {}, //保存详情
      predictionType: "",
      inputEconomic, //经济效益
      infor: {}, //详情
      //定义饲料终端相关数据
      feedPriceDays: [], //table数据
      columnsPrice: [
        {
          title: "阶段",
          dataIndex: "field",
          width: "40%",
          scopedSlots: { customRender: "field" },
        },
        {
          title: "饲料终端价格（元/吨）",
          dataIndex: "price",
          width: "40%",
          scopedSlots: { customRender: "price" },
        },
      ],
    };
  },
  computed: {
    ...mapState("estimate", ["dataDictionary"]),
  },
  created() {
    this.getInfor();
    // this.getDetails("1542806767420919810");
  },
  methods: {
    ...mapMutations("estimate", ["setDataDictionary"]),
    ...mapMutations("economy", ["setPredictionType"]),
    init(record) {
      this.visible = !this.visible;
      this.record = record;
      this.getPredictionType(record.animalTypeId);
      this.getDetails(record.id);
    },
    handleOk() {
      this.visible = false;
    },
    //获取预估记录
    getDetails(id) {
      this.$http
        .get(`/sat-maximization/prediction/detail?id=${id}`)
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            let {
              proteinDpModel,
              growthPerformance,
              feedIntake,
              prediction,
              ipEconomicBenefit,
            } = data;

            this.feedPriceDays=ipEconomicBenefit.feedPriceDays || []

            this.infor = {
              ...proteinDpModel,
              ...growthPerformance,
              ...feedIntake,
              ...prediction,
              ...ipEconomicBenefit,
            };

            //判断当前饲料价格模式
            if(this.infor.feedPriceModel=='FORMULA_OPTIMIZATION_PRICE'){
              this.infor.nhf='NHF配方中读取'
            }else{
              this.infor.nhf=''
            }
            
            let initialBwforaa = null;
            let finalBwforaa = null;
            if (this.record.animalTypeName.includes("教槽")) {
              initialBwforaa = 10;
            } else if (this.record.animalTypeName.includes("保育前期")) {
              initialBwforaa = 10;
            } else if (this.record.animalTypeName.includes("保育后期")) {
              initialBwforaa = 15;
            } else if (this.record.animalTypeName.includes("生长猪")) {
              initialBwforaa = 25;
              finalBwforaa = 50;
            } else if (this.record.animalTypeName.includes("育肥猪")) {
              initialBwforaa = 50;
              finalBwforaa = 100;
            } else if (this.record.animalTypeName.includes("大猪")) {
              initialBwforaa = 100;
              finalBwforaa = 140;
            }

            if (data.weightRangeFormulaList.length == 0) {
              data.weightRangeFormulaList = [
                {
                  initialBwforaa,
                  finalBwforaa,
                },
              ];
            }

            this.dataBase = data;
            this.details = data;
          }
        });
    },

    getInfor() {
      let params = {
        code: "EnergySystem,AminoAcidSystem,PhosphorusSystem,genderOption,currentFeedIntakeOption,actualMeanIntakeOrIntakeCurve,observedMeanIntakeCurveType,CurrentPDPatternNumber,CurrentGrowthPerformanceNumber,EcoModel",
      };
      this.$get("/sat-maximization/dict/listDictByCode", params).then((res) => {
        let { success, data = [] } = res || {};
        if (success) {
          let arrField = {};
          data.forEach((el) => {
            arrField[el.code] = el.dictList || [];
          });
          this.setDataDictionary(arrField);
        }
      });
    },

    // 根据动物类型查询predictionType
    getPredictionType(id) {
      this.$http
        .get(
          `/sat-maximization/predictiontype/predictionTypeByAnimalTypeId?animalTypeId=${id}`
        )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            this.predictionType = data.predictionTypeCode;
          }
        });
    },

    getText(el) {
      let { feild, unit, codeKey } = el || {};
      let val = this.infor[feild];
      let filter = {};
      let str = "";
      if (this.dataDictionary[codeKey]) {
        filter =
          this.dataDictionary[codeKey].find((el) => el.dictKey === val) || {};
        str = filter.dictValue || "-";
        if (feild === "energySystem") this.energySystemName = filter.dictValue;
      } else {
        if (unit === "%") {
          str = val * 100;
        } else {
          str = val === true ? "是" : val === false ? "否" : val;
        }
      }
      if (str == "PencostModelTotal") str = "总栏位成本";
      if (str == "PencostModelDay") str = "日栏位成本";
      if (str == "FORMULA_OPTIMIZATION_PRICE") str = "配方优化价格";
      if (str == "FEED_END_USER_PRICE") str = "饲料终端价格";
      return str;
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  margin-bottom: 20px;
  h3 {
    font-weight: bold;
    margin-bottom: 12px;
  }
  .item {
    width: 100%;
    span {
      display: inline-block;
      width: 50%;
      margin-bottom: 12px;
      font-size: 13px;
    }
  }
}

.group {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .group_item {
    width: 50%;
    font-size: 13px;
    line-height: 36px;
  }
}
</style>
